export default __webpack_public_path__ + "media/images/seals/google-safe-search-66fb312c796b9ddc726a19e917cbbc89.png";